import { Loader2 } from 'lucide-react';
import { cn } from '@/lib/utils';

export type SpinnerSize = 'sm' | 'md' | 'lg' | 'xl';

interface SpinnerProps {
    /** Size of the spinner */
    size?: SpinnerSize;
    /** Additional CSS classes */
    className?: string;
    /** Screen reader label */
    label?: string;
}

const sizeClasses: Record<SpinnerSize, string> = {
    sm: 'h-4 w-4',
    md: 'h-6 w-6',
    lg: 'h-8 w-8',
    xl: 'h-12 w-12',
};

/**
 * Spinner Component
 *
 * A simple, accessible loading spinner.
 *
 * @example
 * <Spinner size="lg" label="Loading products" />
 */
export const Spinner = ({
    size = 'md',
    className,
    label = 'Loading'
}: SpinnerProps) => {
    return (
        <div role="status" aria-label={label}>
            <Loader2
                className={cn('animate-spin text-primary', sizeClasses[size], className)}
                aria-hidden="true"
            />
            <span className="sr-only">{label}</span>
        </div>
    );
};

export default Spinner;
